module.exports = __webpack_public_path__ + "img/bear9.ec1b8eaa.png";